const themeModeLocalStorageKey = "Chat@ThemeMode";
const loggedInUserLocalStorageKey = "Chat@LoggedInUser";
const audioRateLocalStorageKey = "Chat@AudioRate";

export const getThemeMode = () => {
  return localStorage.getItem( themeModeLocalStorageKey );
};

export const setThemeMode = ( newThemeMode: string ) => {
  localStorage.setItem( themeModeLocalStorageKey, newThemeMode );
};

export const clearLegacyLoggedInUser = () => {
  localStorage.removeItem( loggedInUserLocalStorageKey );
};

export const getAudioRateLocalStorage = (): number | null => {
  const audioRate = localStorage.getItem( audioRateLocalStorageKey ) ?? null;

  if( audioRate ) return JSON.parse( audioRate );

  return null;
};

export const setAudioRateLocalStorage = ( audioRate: number | null ) => {
  localStorage.setItem( audioRateLocalStorageKey, JSON.stringify( audioRate ));
};
